import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import Loading from '../Components/Loading';

import styles from '../Styles/Account.module.css';

const Profile = () => {
    const navigate = useNavigate();
    const [user, setUser] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        if (!token) handleLogout();

        axios.get('/api/user', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            if (response.data.approval !== 'Активен') { 
                handleLogout();
                return navigate('/auth/login');
            };
            setUser(response.data);
        }).catch(error => {
            handleLogout();
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setLoading(false);
        });
    }, []);
    
    return (
    <>
        <>
            <div className={styles.verticalData}>
                {loading ? <Loading />
                : warning ? <a>{warning}</a>
                : 
                <>
                <h1>Учётная запись</h1>
                <a>{user.lastname}</a>
                <a>{user.firstname}</a>
                <a>{user.surname}</a>
                </>}
            </div>
            <button type='button' className='button' onClick={() => {navigate('/auth/logout');}}>Выйти из аккаунта</button>
        </>
    </>
    )
}

export default Profile;